import { modals } from '@mantine/modals';
import { IconJson, IconTool } from '@tabler/icons-react';
import { Button, Menu } from '@mantine/core';
import React from 'react';
import { JSONImport } from '~/components/forms/JSONImport';

export default function DataTableAdminOptions() {
  return (
    <Menu transitionProps={{ duration: 0 }}>
      <Menu.Target>
        <Button
          size="compact-sm"
          leftSection={<IconTool size={16} />}
          color="orange"
          variant="light"
        >
          Admin
        </Button>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item
          variant="outline"
          leftSection={<IconJson size={16} />}
          onClick={() =>
            modals.open({
              title: 'Insert the test definition',
              size: 'xl',
              children: <JSONImport />,
            })
          }
        >
          Import Test
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
}
